var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInsuranceIndustry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.365 8.794c-.016-.803-.03-1.56-.03-2.294a1.04 1.04 0 00-1.04-1.04c-4.448 0-7.835-1.278-10.658-4.023a1.04 1.04 0 00-1.45 0C12.365 4.182 8.978 5.46 4.531 5.46A1.04 1.04 0 003.49 6.5c0 .734-.015 1.492-.03 2.294-.143 7.466-.338 17.69 12.11 22.006a1.039 1.039 0 00.682 0c12.45-4.315 12.254-14.54 12.112-22.006zm-12.453 19.92C5.236 24.833 5.397 16.338 5.541 8.833c.008-.45.017-.887.022-1.315 4.166-.176 7.497-1.438 10.35-3.922 2.851 2.484 6.183 3.746 10.35 3.922.005.428.013.864.022 1.314.143 7.505.304 16.002-10.373 19.88z",
    fill: "#ADC6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.494 12.387l-5.02 5.02-2.142-2.143a1.04 1.04 0 00-1.471 1.471l2.877 2.878a1.037 1.037 0 001.471 0l5.756-5.755a1.04 1.04 0 10-1.471-1.471z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/insurance-industry.c77169632247979e0ded1e57337f240f.svg";
export { SvgInsuranceIndustry as ReactComponent };